/*
 * Copyright (c) Airbus SAS. All rights reserved.
 */

/**
 * Enhance the `#switch-user-modal` email field with the shared autocomplete.
 * Mounts on `shown.bs.modal`, tears down on `hidden.bs.modal` so each open
 * starts clean. The impersonation itself is a plain GET form — Symfony's
 * `switch_user` firewall reads `_switch_user` and redirects; no JS navigation.
 *
 * @type {Listener}
 */
export default {
    selector: '#switch-user-modal',
    connect(element, { app }) {
        let autocomplete

        const onShown = async () => {
            const { default: AutocompleteHandler, select2ResponseHandler } = await import(
                '@airbus/mms/js/components/autocomplete/AutocompleteHandler'
            )

            autocomplete = AutocompleteHandler.handle({
                selector: '#switch-user-input',
                url: app.get('urls').usersAutocomplete,
                valueKey: 'email',
                labelKey: 'email',
                inModal: true,
                responseHandler: select2ResponseHandler,
            })
        }

        const onHidden = () => {
            autocomplete?.destroy()
            autocomplete = undefined
        }

        element.addEventListener('shown.bs.modal', onShown)
        element.addEventListener('hidden.bs.modal', onHidden)

        return () => {
            element.removeEventListener('shown.bs.modal', onShown)
            element.removeEventListener('hidden.bs.modal', onHidden)
            autocomplete?.destroy()
            autocomplete = undefined
        }
    },
}
